<template>
    <el-dialog title="联系人手机" :visible.sync="centerDialogVisible" width="600px" class="shopPhone">
        <div class="inputBox">
            <p class="title">联系人手机</p>
            <el-input v-model.trim="phone" placeholder="请输入联系人手机号" maxlength="11" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'shopPhone',
    data() {
        return {
            centerDialogVisible: false,
            phone: ''
        }
    },
    props: ['data'],
    methods: {
        confirm() {
            let telRegular = /^1(3|4|5|7|8)\d{9}$/
            if (telRegular.test(this.phone)) {
                this.setLoading(true)
                updateShopSet({
                    data: {linktel: this.phone},
                    success: data =>{
                        this.setLoading(false)
                        this.$message.success('设置成功')
                        this.centerDialogVisible = false
                        this.$emit('getMsg')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请输入正确的手机号')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.phone = newV.linktel
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .shopPhone{
        .inputBox{
            display: flex;
            align-items: center;
            .title{
                margin: 0 40px 0 32px;
            }
            .el-input{
                width: 400px;
            }
        }
    }
</style>